export const getConfig = () => {
	const project = import.meta.env.VITE_CONTEMBER_ADMIN_PROJECT_NAME as string
	if (!project) {
		throw new Error('VITE_CONTEMBER_ADMIN_PROJECT_NAME is not set')
	}

	const apiBaseUrl = import.meta.env.VITE_CONTEMBER_ADMIN_API_BASE_URL as string
	if (!apiBaseUrl) {
		throw new Error('VITE_CONTEMBER_ADMIN_API_BASE_URL is not set')
	}
	const sessionToken = import.meta.env.VITE_CONTEMBER_ADMIN_SESSION_TOKEN as string
	if (!sessionToken) {
		throw new Error('VITE_CONTEMBER_ADMIN_SESSION_TOKEN is not set')
	}

	return {
		project,
		sessionToken,
		apiBaseUrl,
		stage: 'live',
	}
}
